import dashboard from './dashboard';
import ordering from './ordering';
import marketing from './marketing';
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
    items: [dashboard, ordering, marketing]
};

export default menuItems;
